export enum ImageLayout { 
  'RESPONSIVE' = 'RESPONSIVE',
  'FILL' = 'FILL'
}

export enum ImageObjectFit { 
  'COVER' = 'COVER', 
  'CONTAIN' = 'CONTAIN'
}